/**
 * 브이매치 이전 안내 페이지(public/transfer.html) URL 생성기.
 *
 * 정적 파일의 기준 경로가 환경마다 다르다.
 * - 운영: nginx alias 로 /resume 하위에 서빙 → /resume/transfer.html
 *   (location /resume { alias .../Resume/build/; } — resume_recruit.conf)
 * - 개발: CRA dev server 가 public/ 을 루트에 노출 → /transfer.html
 *
 * 루트 경로(/transfer)로 두면 운영 nginx 의 `location / { return 301 ... }` 에 걸려
 * 회사 홈페이지로 튕기므로 반드시 이 헬퍼를 거쳐야 한다.
 */
const BASE = process.env.NODE_ENV === 'production' ? '/resume' : '';

export const transferNoticeUrl = (from) => `${BASE}/transfer.html?from=${encodeURIComponent(from)}`;

export default transferNoticeUrl;
